var InstallmentCalculatorCar = window.InstallmentCalculatorCar = function () {
    this.price = 260000;
    this.installmentCount = null;
    this.advancePayment = 70;

    this.el = $('.initInstallmentCalculatorCar');
    this.installments = null;
    this.calcChangeEnabled = null;
    this.first = true;
}

InstallmentCalculatorCar.prototype.init = function () {
    var self = this;


    if (self.el.length) {
        self.installments = JSON.parse(JSON.stringify(self.el.data('installments')));
        self.calcChangeEnabled = self.el.data('calc-change-enabled');

        var monthRange = null;
        if (self.installments[0]) {
            this.installmentCount = Object.keys(self.installments[0])[Object.keys(self.installments[0]).length - 1];
        } else {
            this.installmentCount = Object.keys(self.installments[Object.keys(self.installments)[0]])[Object.keys(self.installments[Object.keys(self.installments)[0]]).length - 1];
        }
        switch (this.installmentCount) {
            case '120':
                monthRange = {
                    'min': [12, 12],
                    '11.1%': [24, 12],
                    '22%': [36, 12],
                    '32.8%': [48, 12],
                    '43.8%': [60, 12],
                    '54.4%': [72, 12],
                    '65%': [84, 12],
                    '76.2%': [96, 12],
                    '87.5%': [108, 12],
                    'max': [120]
                };
                break;
            case '108':
                monthRange = {
                    'min': [12, 12],
                    '12.5%': [24, 12],
                    '25%': [36, 12],
                    '37.5%': [48, 12],
                    '50%': [60, 12],
                    '62.5%': [72, 12],
                    '75%': [84, 12],
                    '87.5%': [96, 12],
                    'max': [108]
                };

                $('.calc_value_month_120').addClass('d-none');
                break;
            case '98':
                monthRange = {
                    'min': [12, 12],
                    '13.5%': [24, 12],
                    '28%': [36, 12],
                    '42.5%': [48, 12],
                    '57%': [60, 12],
                    '71%': [72, 12],
                    '85.5%': [84, 12],
                    'max': [96]
                }

                $('.calc_value_month_108').addClass('d-none');
                $('.calc_value_month_120').addClass('d-none');
                break;
            case '96':
                monthRange = {
                    'min': [12, 12],
                    '14.3%': [24, 12],
                    '28.6%': [36, 12],
                    '42.9%': [48, 12],
                    '57.2%': [60, 12],
                    '71.5%': [72, 12],
                    '85.8%': [84, 12],
                    'max': [96]
                }

                $('.calc_value_month_108').addClass('d-none');
                $('.calc_value_month_120').addClass('d-none');
                break;
            case '84':
                monthRange = {
                    'min': [12, 12],
                    '16.6%': [24, 12],
                    '33.32%': [36, 12],
                    '49.98%': [48, 12],
                    '66.64%': [60, 12],
                    '83.3%': [72, 12],
                    'max': [84]
                }

                $('.calc_value_month_96').addClass('d-none');
                $('.calc_value_month_108').addClass('d-none');
                $('.calc_value_month_120').addClass('d-none');
                break;
            case '72':
                monthRange = {
                    'min': [12, 12],
                    '20%': [24, 12],
                    '40%': [36, 12],
                    '60%': [48, 12],
                    '80%': [60, 12],
                    'max': [72],
                }
                $('.calc_value_month_84').addClass('d-none');
                $('.calc_value_month_96').addClass('d-none');
                $('.calc_value_month_108').addClass('d-none');
                $('.calc_value_month_120').addClass('d-none');
                break;
        }

        // month slider
        var month_price = document.getElementById('calc_slider_month');

        noUiSlider.create(month_price, {
            connect: 'lower',
            start: [this.installmentCount],
            range: monthRange,
            format: wNumb({
                decimals: 0,
                thousand: ' ',
            })
        });

        $('.calc_value_month').on('click', function () {
            month_price.noUiSlider.set($(this).data('number'));
        });

        //set value from slider
        var monthPriceField = document.getElementById('calc--month');
        month_price.noUiSlider.on('update', function (values, handle) {
            monthPriceField.innerHTML = values[handle];
            self.installmentCount = parseInt(values[handle].replace(' ', '').replace(' ', ''));
            self.changePrice();

            // Add active class to the matching element
            var elements = document.querySelectorAll('.calc_value_month');
            elements.forEach(function (element) {
                if (parseInt(element.getAttribute('data-number')) === self.installmentCount) {
                    element.classList.add('active');
                } else {
                    element.classList.remove('active');
                }
            });
        });


        // akontace slider
        var akontaceSlider = document.getElementById('calc_slider_akontace');

        noUiSlider.create(akontaceSlider, {
            connect: 'lower',
            start: [this.advancePayment],
            range: {
                'min': [0, 10],
                '13.5%': [10, 5],
                '27.5%': [15, 10],
                '41%': [25, 10],
                '55.5%': [35, 10],
                '70%': [45, 10],
                '84%': [55, 25],
                'max': [70]
            },
            format: wNumb({
                decimals: 0,
                thousand: ' ',
            })
        });

        $('.calc_value_akontace').on('click', function () {
            akontaceSlider.noUiSlider.set($(this).data('number'));
        });

        //set value from slider
        // var akontacePriceField = document.getElementById('calc--car_akontace');
        akontaceSlider.noUiSlider.on('update', function (values, handle) {
            // akontacePriceField.innerHTML = values[handle];
            self.advancePayment = parseInt(values[handle].replace(' ', '').replace(' ', ''));
            self.changePrice();

            // Add active class to the matching element
            var elements = document.querySelectorAll('.calc_value_akontace');
            elements.forEach(function (element) {
                if (parseInt(element.getAttribute('data-number')) === self.advancePayment) {
                    element.classList.add('active');
                } else {
                    element.classList.remove('active');
                }
            });
        });
    }
}

InstallmentCalculatorCar.prototype.changePrice = function () {
    // var price = Math.round((this.price * (1 - this.advancePayment / 100) / this.installmentCount * this.getCoefficient()));
    var price = this.installments[this.advancePayment][this.installmentCount];

    $('input[name="akontace_value"]').val(this.advancePayment);
    $('input[name="doba_value"]').val(this.installmentCount);

    if (this.calcChangeEnabled || (!this.calcChangeEnabled && this.first)) {
        $('input[name="splatka_value"]').val(Math.round(price));
    }

    // if ($('#dayPrice').length && (this.calcChangeEnabled || (!this.calcChangeEnabled && this.first))) {
    //     $('#dayPrice .dayPrice').html(this.formatCena(this.getSplatka() / 30.4));
    // }

    if (this.calcChangeEnabled) {
        // this.elements.html(this.formatCena(this.getSplatka()));
        $('.calculator_output #calc--month_price').html(this.formatCena(price));
    } else if (!this.calcChangeEnabled && this.first) {
        // this.elements.val(this.getSplatka());
        $('.calculator_output #calc--month_price').html(this.formatCena(price));

        $('.calculator_output input').keyup(function () {
            // $('#dayPrice .dayPrice').html(self.formatCena(self.elements.val() / 30.4));
            $('input[name="splatka_value"]').val(Math.round($('.calculator_output input').val()));
        });
    }

    this.first = false;


};

InstallmentCalculatorCar.prototype.formatCena = function (cena) {
    var re = '\\d(?=(\\d{' + 3 + '})+$)';
    return cena.toFixed(0).replace(new RegExp(re, 'g'), '$& ') + ' Kč';
};